import { render, staticRenderFns } from "./CasesIncluded.vue?vue&type=template&id=66638e04&scoped=true&"
import script from "./CasesIncluded.vue?vue&type=script&lang=js&"
export * from "./CasesIncluded.vue?vue&type=script&lang=js&"
import style0 from "./CasesIncluded.vue?vue&type=style&index=0&id=66638e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66638e04",
  null
  
)

export default component.exports